import { uniq } from 'ramda';

/**
 * Check that the given array has no duplicates
 * @param referenceArray
 * @returns true if the array has no duplicates
 */
export const hasNoDuplicates = (referenceArray: Array<string>): boolean => {
  return uniq(referenceArray).length === referenceArray.length;
};

/**
 * @param referenceArray
 * @param elements
 * @returns true if all elements are included in the reference array
 */
export const elementsAreIncludedInArray = (
  referenceArray: Array<string>,
  elements: Array<string>,
): boolean => {
  return elements.every((element) => referenceArray.includes(element));
};
